import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages as ptMessages } from "./languages/pt";
import { messages as enMessages } from "./languages/en";
import { messages as esMessages } from "./languages/es";

const resources = {
  ...ptMessages,
  ...enMessages,
  ...esMessages,
};

i18n.use(LanguageDetector).init({
  resources,
  fallbackLng: "pt",
  supportedLngs: ["pt", "en", "es"],
  // our resources are keyed under the "translations" namespace
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: { escapeValue: false },
});

export { i18n };
export default i18n;
